module.exports = __webpack_public_path__ + "static/cloud-2-c82fa524964519aca3ef99ed93c85fee.png";